import {
  THEME_STYLESHEET_V1
} from 'themes_const_shared/theme_stylesheet_versions.js';

import {
  convertStylePresetsToOptionsList
} from 'zoomforth_codesbane_editor/lib/style_presets.js';

import {
  MASK_CUSTOM_FOOTER_STATE,
} from 'zoomforth_codesbane_editor/action_types.js';

export default (state = {}, action)=> {

  switch (action.type) {

  case MASK_CUSTOM_FOOTER_STATE: {
    return {
      ...state,
      customFooterHtml: action.customFooterHtml
    };
  }

  default: {
    return state;
  }

  }
};

export const getCurrentThemeUuid = (state)=>
  state.uuid;

export const getCustomFooterHtml = (state)=>
  state.customFooterHtml;

export const getMostCommonThemeFontColors = (state)=>
  state.mostCommonFontColors;

export const getMostCommonThemeBackgroundColors = (state)=>
  state.mostCommonBackgroundColors;

export const getUseFixedNavLinks = (state)=>
  state.useFixedNavLinks;

export const getIsUsingV1Styles = (state)=>
  state.stylesheetVersion === THEME_STYLESHEET_V1;

export const getStylePresets = (state)=>
  convertStylePresetsToOptionsList(state.stylePresets, { includeDefaultValue: true });
